import http from "../http-common";

class CausalesService {

    getId(id) {
        return http.get(`/causalmaestro/${id}`);
    }

    update(id, data) {
        return http.put(`/causalmaestro/${id}`,data);
    }

    getAll() {
        return http.get("/causalmaestro");
    }

    getAllPages(page, size) {
        return http.get(`/causalmaestro/pages/p?page=${page}&size=${size}`)
    }
}

export default new CausalesService();